var _path, _path2, _g, _path3, _path4, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShoubing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 93,
    viewBox: "0 0 63 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.7697 41.9805C48.1528 39.1048 50.563 36.93 53.4628 36.8437C57.1131 36.7349 59.9907 39.9241 59.5086 43.5441L53.7347 86.8927C53.3517 89.7685 50.9415 91.9432 48.0416 92.0296C44.3913 92.1383 41.5137 88.9491 41.9959 85.3292L47.7697 41.9805Z",
    fill: "#120E1D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5851 42.1403L53.5807 41.8425L54.5038 72.8287L44.5082 73.1265L43.5851 42.1403Z",
    fill: "url(#paint0_linear_1979_5)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bii_1979_5)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 47.8002,
    cy: 32.5104,
    r: 12.5,
    transform: "rotate(-1.70642 47.8002 32.5104)",
    fill: "#8A3523"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.18754 41.965C8.65604 39.102 11.1299 37 14.0311 37C17.683 37 20.4643 40.2735 19.8746 43.8775L12.8125 87.035C12.344 89.898 9.87008 92 6.96893 92C3.31703 92 0.535662 88.7265 1.1254 85.1225L8.18754 41.965Z",
    fill: "#120E1D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 22H18V53H8V22Z",
    fill: "url(#paint1_linear_1979_5)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_bii_1979_5)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    fill: "#8A3523"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bii_1979_5",
    x: -24.6999,
    y: -39.9897,
    width: 145,
    height: 145,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 30
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1979_5"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1979_5",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.65098 0 0 0 0 0.545098 0 0 0 0 0.772549 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_1979_5"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.65098 0 0 0 0 0.545098 0 0 0 0 0.772549 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_1979_5",
    result: "effect3_innerShadow_1979_5"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_bii_1979_5",
    x: -60,
    y: -60,
    width: 145,
    height: 145,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 30
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1979_5"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1979_5",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.65098 0 0 0 0 0.545098 0 0 0 0 0.772549 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_1979_5"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.65098 0 0 0 0 0.545098 0 0 0 0 0.772549 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_1979_5",
    result: "effect3_innerShadow_1979_5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1979_5",
    x1: 48.5829,
    y1: 41.9914,
    x2: 49.506,
    y2: 72.9776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#907FA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#120E1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1979_5",
    x1: 13,
    y1: 22,
    x2: 13,
    y2: 44.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#907FA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#120E1D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoubing);
export default __webpack_public_path__ + "static/media/shoubing.472636ea5adff1cc858e33bff97ce54e.svg";
export { ForwardRef as ReactComponent };